export default {
  // Page metadata
  'meta.title': 'Ketentuan Layanan - timer.today',
  'meta.description': 'Ketentuan Layanan dan perjanjian penggunaan untuk platform alat pengatur waktu online timer.today. Pelajari tentang aturan layanan kami, hak dan tanggung jawab pengguna.',

  // Page header
  'page.title': 'Ketentuan Layanan',
  'page.lastUpdated': 'Terakhir diperbarui: {{date}}',
  'page.intro': 'Selamat datang di timer.today. Ketentuan dan kondisi ini menguraikan aturan dan peraturan untuk penggunaan Situs Web timer.today, yang terletak di timer.today.',

  // Section 1
  'section1.title': '1. Penerimaan Ketentuan',
  'section1.content': 'Dengan mengakses dan menggunakan situs web ini, Anda menerima dan setuju untuk terikat dengan ketentuan dan ketentuan perjanjian ini. Jika Anda tidak setuju untuk mematuhi hal-hal di atas, harap jangan gunakan layanan ini.',

  // Section 2
  'section2.title': '2. Deskripsi Layanan',
  'section2.intro': 'timer.today menyediakan alat pengatur waktu online gratis termasuk:',
  'section2.timer': 'Timer Hitung Mundur - Timer yang dapat disesuaikan untuk produktivitas, memasak, dan manajemen waktu',
  'section2.stopwatch': 'Stopwatch - Alat pengatur waktu presisi tinggi untuk olahraga, pelatihan, dan pengaturan waktu yang tepat',
  'section2.worldclock': 'Jam Dunia - Tampilan real-time zona waktu global',

  // Section 3
  'section3.title': '3. Lisensi Penggunaan',
  'section3.intro': 'Izin diberikan untuk sementara menggunakan timer.today hanya untuk tampilan pribadi, non-komersial yang bersifat sementara. Ini adalah pemberian lisensi, bukan transfer hak milik, dan di bawah lisensi ini Anda tidak boleh:',
  'section3.item1': 'memodifikasi atau menyalin materi',
  'section3.item2': 'menggunakan materi untuk tujuan komersial atau untuk tampilan publik apa pun',
  'section3.item3': 'mencoba merekayasa balik perangkat lunak apa pun yang terdapat di situs web',
  'section3.item4': 'menghapus hak cipta atau notasi kepemilikan lainnya dari materi',

  // Section 4
  'section4.title': '4. Privasi dan Data',
  'section4.intro': 'timer.today berkomitmen untuk melindungi privasi Anda:',
  'section4.item1': 'Kami tidak mengumpulkan atau menyimpan informasi pribadi',
  'section4.item2': 'Pengaturan timer disimpan secara lokal di browser Anda',
  'section4.item3': 'Kami tidak melacak perilaku pengguna atau pola penggunaan',
  'section4.item4': 'Tidak ada cookie yang digunakan untuk tujuan pelacakan',

  // Section 5
  'section5.title': '5. Penafian',
  'section5.content': 'Materi di timer.today disediakan \'sebagaimana adanya\'. timer.today tidak memberikan jaminan, tersurat atau tersirat, dan dengan ini menafikan dan meniadakan semua jaminan lain termasuk tanpa batasan, jaminan tersirat atau kondisi kelayakan untuk diperdagangkan, kesesuaian untuk tujuan tertentu, atau non-pelanggaran kekayaan intelektual atau pelanggaran hak lainnya.',

  // Section 6
  'section6.title': '6. Batasan',
  'section6.content': 'Dalam keadaan apa pun timer.today atau pemasoknya tidak bertanggung jawab atas kerusakan apa pun (termasuk, tanpa batasan, kerusakan untuk kehilangan data atau keuntungan, atau karena gangguan bisnis) yang timbul dari penggunaan atau ketidakmampuan untuk menggunakan materi di timer.today, bahkan jika timer.today atau perwakilan resminya telah diberitahu secara lisan atau tertulis tentang kemungkinan kerusakan tersebut.',

  // Section 7
  'section7.title': '7. Akurasi Materi',
  'section7.content': 'Materi yang muncul di timer.today dapat mencakup kesalahan teknis, tipografi, atau fotografi. timer.today tidak menjamin bahwa materi apa pun di situs webnya akurat, lengkap, atau terkini. timer.today dapat membuat perubahan pada materi yang terdapat di situs webnya kapan saja tanpa pemberitahuan.',

  // Section 8
  'section8.title': '8. Modifikasi',
  'section8.content': 'timer.today dapat merevisi ketentuan layanan ini untuk situs webnya kapan saja tanpa pemberitahuan. Dengan menggunakan situs web ini, Anda setuju untuk terikat dengan versi ketentuan layanan ini yang berlaku saat itu.',

  // Section 9
  'section9.title': '9. Informasi Kontak',
  'section9.intro': 'Jika Anda memiliki pertanyaan tentang Ketentuan Layanan ini, silakan hubungi kami di:',
  'section9.email': 'Email:',
  'section9.emailSubject': 'Pertanyaan Ketentuan Layanan - timer.today',

  // Footer
  'footer.copyright': '© timer.today 2024. Semua hak dilindungi.'
};